import { HttpAuth } from '../../config/Http'
import { changeNotify } from './notify.action'
import { changeLoading } from './loading.action'
import { changeAlert } from './alert.action'
import { rootUrl } from '../../config/App'

export const actionTypes = {
    INDEX: 'COTAS_INDEX',
    SUCCESS: 'COTAS_SUCCESS',
    ERROR: 'COTAS_ERROR'
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

// INDEX

export const indexResponse = (payload, isLoadMore) => ({
    type: actionTypes.INDEX,
    payload,
    isLoadMore
})

export const index = (campaign_id, query, isLoadMore) => dispatch => {
    
    return HttpAuth.post('/transactions/'+ campaign_id, query)
            .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data, isLoadMore)))
            .catch(error => {
                dispatch( changeLoading({ open: false }) );
        
                if(typeof error.response !== 'undefined') {
                    if(error.response.status === 400) {
                        if(typeof error.response.data === 'object'){
                            
                            if(typeof error.response.data.error !== undefined) {
                                if(typeof error.response.data.error === 'string'){
                                    dispatch( changeNotify({
                                        open: true,
                                        class: 'error',
                                        msg: error.response.data.error
                                    }))
                                }
                            }
    
                            if(typeof error.response.data.class !== undefined) {
                                dispatch(changeNotify({
                                    open: true,
                                    msg: error.response.data.msg,
                                    class: error.response.data.class
                                }))
                                dispatch(success(true))
                            }
                        }
                    }
                }
            })
}

// SHOW

export const show = (id) => dispatch => {
    return HttpAuth.get('/transactions/'+ id)
        .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
        .catch(erro => {
            if(erro.response) {
                dispatch(changeNotify({
                    open: true,
                    msg: erro.response.data.msg,
                    class: erro.response.data.class
                }))
                dispatch(success(true))
            }
        })
}

// RENOTIFICATE

export const renotificate = (id) => dispatch => {
    dispatch(changeLoading({ 
        open: true,
        block: true,
    }))

    return HttpAuth.get('/transactions/renotification/'+ id)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            if(typeof res !== 'undefined'){
                if(res.data.success === 200) {
                    dispatch(changeAlert({
                        open: true,
                        msg: res.data.msg,
                        class: res.data.class,
                        time: 5000
                    }))
                }
            }
        })
        .catch(erro => {
            dispatch(changeLoading({ open: false }))
            if(erro.response) {
                dispatch(changeAlert({
                    open: true,
                    msg: erro.response.data.msg,
                    class: erro.response.data.class,
                    time: 5000
                }))
                dispatch(success(true))
            }
        })
}

// REDIRECT VIEW

export const redirectView = (transaction_id, url_amigavel) => dispatch => {
    dispatch(changeLoading({ 
        open: true,
        block: true,
    }))
    
    const winName = `redirect_${transaction_id}_${Date.now()}`;
    const popup = window.open('about:blank', winName);

    return HttpAuth.post('/transactions/redirect-view/'+ transaction_id)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            if(typeof res !== 'undefined'){
                if(res.data.token && popup) {
                    const form = document.createElement('form');
                    const secureUrl = rootUrl.replace('api.', '');
                    form.action = secureUrl+'redirect-view/'+transaction_id+'/'+url_amigavel+'/post';
                    form.method = 'POST';
                    form.target = winName;

                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = 'code';
                    input.value = res.data.token;

                    form.appendChild(input);

                    form.style.display = 'none';
                    
                    document.body.appendChild(form);
                    form.submit();
                    form.remove();
                }
            }
        })
        .catch(erro => {
            dispatch(changeLoading({ open: false }))
            if(erro.response) {
                dispatch(changeAlert({
                    open: true,
                    msg: erro.response.data.msg,
                    class: erro.response.data.class,
                    time: 5000
                }))
            }
        })
}

// CONSULT

export const consult = (id) => dispatch => {
    dispatch(changeLoading({ 
        open: true
    }))

    return HttpAuth.get('/transactions/consult/'+ id)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            if(typeof res !== 'undefined'){
                if(res.data.success === 200) {
                    dispatch(show(id))
                    dispatch(changeAlert({
                        open: true,
                        msg: res.data.msg,
                        class: res.data.class,
                        time: 5000
                    }))
                }
            }
        })
        .catch(erro => {
            dispatch(changeLoading({ open: false }))
            if(erro.response) {
                dispatch(changeAlert({
                    open: true,
                    msg: erro.response.data.msg,
                    class: erro.response.data.class,
                    time: 5000
                }))
                dispatch(success(true))
            }else {
                dispatch(changeAlert({
                    open: true,
                    msg: 'O Banco paggue não esta retornando a solicitação.',
                    class: 'error',
                    time: 5000
                }))
            }
        })
}